import classNames from "classnames";
import { externalLink } from "core/links";
import { openExternalLink } from "core/javascriptChannels";
import { HubLinkSummary } from "shared/request/myHealthyAdvantageApi";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { getLinkImageSrc } from "shared/utils/url";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";

export interface OtherSiteCardProps {
  hubLink: HubLinkSummary;
  className?: string;
}

export const OtherSiteCard = ({ hubLink, className }: OtherSiteCardProps) => {
  const isMobileApp = !!window.flutter_inappwebview;
  const clientCode = ClientInfoState.getCode() ?? "";
  const imageSrc = getLinkImageSrc(hubLink.image, clientCode);

  const openHubLink = () => (isMobileApp ? openExternalLink(hubLink.linkUrl) : externalLink(hubLink.linkUrl));

  return (
    <button type="button" className={classNames("block w-full", className)} aria-label={imageSrc} onClick={openHubLink}>
      <RoundedCard className="flex items-center justify-center h-[100px]">
        <img src={imageSrc} alt="" className="max-h-full max-w-full object-contain" />
      </RoundedCard>
    </button>
  );
};
